/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `ConsoleInstanceBaseHostingType*`'s.
 */
export type ConsoleInstanceBaseHostingType =
  | ConsoleInstanceBaseHostingTypeSaas
  | ConsoleInstanceBaseHostingTypeDedicated
  | ConsoleInstanceBaseHostingTypeMultiTenanted;

/**
 * The base hosting type of a saas instance.
 * @export
 */
export type ConsoleInstanceBaseHostingTypeSaas = typeof CONSOLE_INSTANCE_BASE_HOSTING_TYPE_SAAS;

/**
 * The base hosting type of a dedicated instance.
 * @export
 */
export type ConsoleInstanceBaseHostingTypeDedicated = typeof CONSOLE_INSTANCE_BASE_HOSTING_TYPE_DEDICATED;

/**
 * The base hosting type of a multi-tenanted instance.
 * @export
 */
export type ConsoleInstanceBaseHostingTypeMultiTenanted = typeof CONSOLE_INSTANCE_BASE_HOSTING_TYPE_MULTI_TENANTED;

/**
 * The base hosting type of a saas instance.
 * @export
 */
export const CONSOLE_INSTANCE_BASE_HOSTING_TYPE_SAAS = `saas`;

/**
 * The base hosting type of a dedicated instance.
 * @export
 */
export const CONSOLE_INSTANCE_BASE_HOSTING_TYPE_DEDICATED = `dedicated`;

/**
 * The base hosting type of a multi-tenanted instance.
 * @export
 */
export const CONSOLE_INSTANCE_BASE_HOSTING_TYPE_MULTI_TENANTED = `multi-tenanted`;
